<template>
    <div>
        <app-header></app-header>
        <div class="container-fluid">
            <div class="row">
                <app-sidebar></app-sidebar>
                <div class="col painel-content">
                    <router-view/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AppHeader from '../components/header/Main';
    import AppSidebar from '../components/sidebar/Main';

    export default {
        name: 'DefaultLayout',
        components: {
            AppHeader,
            AppSidebar
        }
    }
</script>
<style lang="scss">
</style>
